module.exports = __webpack_public_path__ + "img/message-exam@3x.13306ded.png";